export const COUNTRY_CODES: Record<string, string> = {
  US:'1',CA:'1',PR:'1787',VI:'1340',GU:'1671',AS:'1684',MP:'1670',
  BS:'1242',BB:'1246',AI:'1264',AG:'1268',VG:'1284',KY:'1345',BM:'1441',
  GD:'1473',TC:'1649',MS:'1664',SX:'1721',LC:'1758',DM:'1767',VC:'1784',
  DO:'1809',TT:'1868',KN:'1869',JM:'1876',
  // Europe
  GB:'44',FR:'33',DE:'49',IT:'39',ES:'34',PT:'351',NL:'31',BE:'32',
  CH:'41',AT:'43',SE:'46',NO:'47',DK:'45',FI:'358',PL:'48',IE:'353',
  GR:'30',CZ:'420',HU:'36',RO:'40',BG:'359',HR:'385',RS:'381',SI:'386',
  SK:'421',EE:'372',LV:'371',LT:'370',IS:'354',AL:'355',BA:'387',ME:'382',
  MK:'389',MD:'373',LU:'352',MT:'356',CY:'357',AD:'376',MC:'377',SM:'378',
  VA:'379',LI:'423',GI:'350',IM:'44',JE:'44',GG:'44',FO:'298',XK:'383',
  UA:'380',BY:'375',RU:'7',KZ:'7',
  // South & Central America
  BR:'55',MX:'52',AR:'54',CO:'57',CL:'56',PE:'51',VE:'58',EC:'593',
  GT:'502',CU:'53',BO:'591',HT:'509',HN:'504',PY:'595',NI:'505',SV:'503',
  CR:'506',PA:'507',UY:'598',GY:'592',SR:'597',BZ:'501',AW:'297',CW:'599',
  // Middle East & Arab World
  AE:'971',SA:'966',EG:'20',IQ:'964',MA:'212',DZ:'213',SD:'249',QA:'974',
  SY:'963',TN:'216',YE:'967',JO:'962',LB:'961',OM:'968',KW:'965',PS:'970',
  BH:'973',LY:'218',SO:'252',MR:'222',DJ:'253',KM:'269',IL:'972',TR:'90',
  IR:'98',
  // South Asia
  IN:'91',PK:'92',BD:'880',LK:'94',NP:'977',AF:'93',BT:'975',MV:'960',
  // East & Southeast Asia
  CN:'86',ID:'62',JP:'81',PH:'63',VN:'84',TH:'66',MM:'95',KR:'82',
  MY:'60',TW:'886',HK:'852',KH:'855',LA:'856',SG:'65',MN:'976',MO:'853',
  BN:'673',TL:'670',KP:'850',
  // Central Asia & Caucasus
  UZ:'998',AZ:'994',TJ:'992',GE:'995',KG:'996',TM:'993',AM:'374',
  // Africa
  NG:'234',ET:'251',CD:'243',TZ:'255',ZA:'27',KE:'254',UG:'256',AO:'244',
  MZ:'258',GH:'233',MG:'261',CI:'225',CM:'237',NE:'227',BF:'226',ML:'223',
  MW:'265',ZM:'260',SN:'221',TD:'235',ZW:'263',GN:'224',RW:'250',BJ:'229',
  BI:'257',SS:'211',TG:'228',SL:'232',CG:'242',LR:'231',CF:'236',ER:'291',
  NA:'264',GM:'220',BW:'267',GA:'241',LS:'266',GW:'245',GQ:'240',MU:'230',
  SZ:'268',CV:'238',ST:'239',SC:'248',
  // Oceania & Pacific
  AU:'61',PG:'675',NZ:'64',FJ:'679',SB:'677',VU:'678',WS:'685',FM:'691',
  TO:'676',KI:'686',PW:'680',MH:'692',TV:'688',NR:'674',CK:'682',NU:'683',
  NC:'687',PF:'689',
};

export const POPULAR_COUNTRIES = ['IN','AE','US','GB','SA','SG','AU','CA','PK','BD','MY','QA','KW','OM','BH'];
